import * as THREE from 'three';
import { WorldRenderer } from '../../../WorldRenderer';
import { TextGeometry } from 'three/examples/jsm/geometries/TextGeometry';
export class C4Container {
  obj: THREE.Group<THREE.Object3DEventMap>;
  constructor(public wr: WorldRenderer) {
    this.obj = new THREE.Group();
    const boxHeight = 2.75;
    const boxWidth = 2.2;
    const boxLength = 12.0;
    const box = new THREE.Mesh(

      new THREE.BoxGeometry(boxLength, boxWidth, boxHeight),
      new THREE.MeshStandardMaterial({
        color: 0x900000,
        roughness: 0.5,
        metalness: 0.5
      })
    );
    box.position.set(0, 0, boxHeight / 2);
    this.obj.add(box);
    const label = new THREE.Mesh(
      new TextGeometry("HAKUNA MATATA", {
        font: this.wr.dataService.font,
        size: 0.75,
        depth: 0.005,
      }),
      new THREE.MeshStandardMaterial({
        color: 0xffffff,
        roughness: 0.85,
        metalness: 0.85
      })
    );
    label.position.set(
      boxLength / 2 - 1.0, 
      boxWidth / 2 + 0.1, 
      0.1
    );
    label.rotation.x = -Math.PI / 2;
    label.rotation.z = Math.PI;
    box.add(label);
  }
}